<template>
  <div class="text-xs-center">
    <v-dialog persistent="" v-model="dialog" fullscreen>
      <v-card>
        <v-toolbar dark color="primary">
          <v-toolbar-title>{{ titleAction }}</v-toolbar-title>
          <v-spacer></v-spacer>
          <v-toolbar-items>
            <v-btn icon dark @click="cancel()">
              <v-icon>close</v-icon>
            </v-btn>
          </v-toolbar-items>
        </v-toolbar>
        <v-card-text>
          <v-container fluid>
            <v-layout wrap row>
              <v-flex xs12 px-2>
                <v-switch
                  v-model="localAspect.active"
                  :disabled="!Edit"
                  :label="$t('active')"
                  color="primary"
                ></v-switch>
              </v-flex>
              <v-flex xs12 px-2>
                <translation-field
                  v-model="localAspect.name"
                  :label="$t('name')"
                  ref="name"
                  required
                  :disabled="!Edit"
                />
              </v-flex>
              <v-flex md3 sm3 xs12 px-2>
                <v-autocomplete
                  v-model="localAspect.type"
                  :label="$t('select', { field: $t('type') })"
                  :items="types"
                  :disabled="!Edit"
                  :data-vv-name="$t('type')"
                  :error-messages="errors.collect($t('type'))"
                  v-validate="'required'"
                ></v-autocomplete>
              </v-flex>
              <v-flex md3 sm6 xs12 px-2>
                <v-autocomplete
                  v-model="localAspect.typeScore"
                  :label="$t('select', { field: $t('typeScore') })"
                  :items="typeScore"
                  :disabled="!Edit"
                  :data-vv-name="$t('typeScore')"
                  :error-messages="errors.collect($t('typeScore'))"
                  v-validate="'required'"
                ></v-autocomplete>
              </v-flex>
              <v-flex v-if="localAspect.typeScore === 'select'" md4 xs12 px-2>
                <v-text-field
                  v-model="localAspect.untilSelect"
                  :label="$t('untilScore')"
                  :disabled="!Edit"
                  type="number"
                  :data-vv-name="$t('untilScore')"
                  :error-messages="errors.collect($t('untilScore'))"
                  v-validate="'required'"
                ></v-text-field>
              </v-flex>
              <v-flex v-if="localAspect.typeScore === 'options'" md6 xs12 px-2>
                <OptionList
                  :items="localAspect.options || []"
                  @add="openOptionModal"
                  @edit="openOptionModal"
                  @delete="deleteOption"
                />
              </v-flex>
            </v-layout>
          </v-container>
        </v-card-text>
        <v-divider></v-divider>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn small @click="reset()" color="warning" v-if="Edit">
            {{ $t('reset') }}
          </v-btn>
          <v-btn
            small
            @click="sendCreate()"
            color="success"
            :loading="loading"
            v-if="externalAction === 'create' && can('create', 'aspect')"
          >
            {{ $t('accept') }}
          </v-btn>
          <v-btn
            small
            @click="sendUpdate()"
            color="secondary"
            :loading="loading"
            v-if="
              externalAction === 'update' &&
                can('edit', 'aspect', externalAspect)
            "
          >
            {{ $t('update') }}
          </v-btn>
          <v-btn
            small
            @click="sendDelete()"
            color="error"
            :loading="loading"
            v-if="
              externalAction === 'delete' &&
                can('delete', 'aspect', externalAspect)
            "
          >
            {{ $t('delete') }}
          </v-btn>
          <v-btn small @click="cancel()" color="primary">
            {{ $t('cancel') }}
          </v-btn>
        </v-card-actions>
      </v-card>
      <OptionModal
        :modal="optionModal"
        :item="option"
        @add="addOption"
        @close="optionModal = false"
      />
    </v-dialog>
  </div>
</template>
<script>
import { mapActions, mapState } from 'vuex'
import rules from '../../../helpers/rules'
import TranslationField from '@/components/widgets/Input/TranslationField'
import OptionList from './components/OptionList'
import OptionModal from './components/OptionModal'
import { parseObject } from '@/helpers/utils'

export default {
  name: 'formManager',
  mixins: [rules],
  components: { OptionList, OptionModal, TranslationField },
  props: {
    externalState: {
      type: Boolean,
      default: false,
      required: false
    },
    externalAction: {
      type: String,
      default: 'create',
      required: false
    },
    externalAspect: {
      type: Object,
      default: () => {
        return {
          active: true
        }
      },
      required: false
    },
    modal: {
      type: Boolean,
      required: true
    }
  },
  data() {
    return {
      types: [
        {
          text: this.$t('types.tournament'),
          value: 'tournament'
        },
        {
          text: this.$t('types.league'),
          value: 'league'
        },
        {
          text: this.$t('types.friendly'),
          value: 'friendly'
        },
        {
          text: this.$t('types.user'),
          value: 'user'
        }
      ],
      typeScore: [
        {
          text: this.$t('checkbox'),
          value: 'checkbox'
        },
        {
          text: this.$t('dropdown'),
          value: 'select'
        },
        {
          text: this.$t('textbox'),
          value: 'textbox'
        },
        {
          text: this.$t('options'),
          value: 'options'
        }
      ],
      Edit: true,
      localAspect: {
        active: true
      },
      optionModal: false,
      loading: false,
      option: {}
    }
  },
  watch: {
    externalState(val) {
      this.dialog = val
    },
    externalAction(val) {
      this.initData(this.externalAspect, val)
    },
    externalAspect: {
      handler: function(val) {
        this.initData(val, this.externalAction)
      },
      deep: true,
      immediate: true
    },
    'localAspect.typeScore': {
      handler: function(val) {
        if (val != 'select') this.localAspect.untilSelect = ''
        if (val != 'options') this.localAspect.options = []
      }
    }
  },
  computed: {
    ...mapState({
      languages: state => state.languages.listLanguages
    }),
    titleAction() {
      switch (this.externalAction) {
        case 'create':
          return this.$t('newModel', { field: this.$tc('aspect') })
        case 'delete':
          return this.$t('deleteModel', { field: this.$tc('aspect') })
        case 'update':
          return this.$t('updateModel', { field: this.$tc('aspect') })
      }
    },
    dialog: {
      get() {
        return this.modal
      },
      set(value) {
        if (!value) {
          this.$emit('close')
        }
      }
    }
  },
  mounted() {
    this.initData(this.externalAspect, this.externalAction)
  },
  methods: {
    ...mapActions({
      createNew: 'aspects/setNew',
      updateAspect: 'aspects/setUpdate',
      deleteAspect: 'aspects/setDelete',
      setClearOne: 'aspects/setClearOne'
    }),
    initData(aspect, action) {
      const { options, ...item } = parseObject(aspect)
      this.localAspect = { ...item, options: [] }
      if (aspect.options)
        this.localAspect.options = aspect.options.map(option =>
          parseObject(option)
        )
      this.Edit = action !== 'delete'
    },
    openOptionModal(option) {
      this.option = option ? option : {}
      this.optionModal = true
    },
    addOption(option) {
      const property = option.hasOwnProperty('_id') ? '_id' : 'key'
      const options = this.localAspect.options || []
      this.localAspect.options = [
        ...options.filter(item => item[property] != option[property]),
        option
      ].sort((a, b) => a.value - b.value)
    },
    deleteOption(option) {
      const property = Object.hasOwnProperty('_id') ? '_id' : 'key'
      this.localAspect.options = this.localAspect.options.filter(
        item => item[property] != option[property]
      )
    },
    sendCreate() {
      Promise.all([this.validate(), this.$refs.name.validate()]).then(valid => {
        if (valid.some(valid => !valid)) return

        this.loading = true
        this.createNew(this.localAspect)
          .then(_ => {
            this.dialog = false
            this.reset()
          })
          .finally(_ => (this.loading = false))
      })
    },
    sendUpdate() {
      Promise.all([this.validate(), this.$refs.name.validate()]).then(valid => {
        if (valid.some(valid => !valid)) return

        this.loading = true
        this.updateAspect(this.localAspect)
          .then(_ => {
            this.dialog = false
            this.reset()
          })
          .finally(_ => (this.loading = false))
      })
    },
    sendDelete() {
      this.loading = true
      this.deleteAspect(this.externalAspect._id)
        .then(_ => {
          this.dialog = false
          this.reset()
        })
        .finally(_ => (this.loading = false))
    },
    reset() {
      this.setClearOne()
      this.localAspect = {}
      this.$validator.reset()
      this.$nextTick(() => {
        this.$refs.name.$validator.reset()
      })
    },
    cancel() {
      this.dialog = false
      this.reset()
    }
  }
}
</script>
